import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { MasterscreenService } from 'src/app/masterscreen/services/masterscreen.service';
import { SearchText } from 'src/app/observation/model/searchTexts.model';
import { BaseService } from 'src/app/shared/services/base.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { NotificationsService } from 'src/app/shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { TNCFilter } from '../../model/TNCFilter.model';
import { TNCUserProfiles } from '../../model/TNCGetUserProfiles.model';
import { TncConstantsService } from '../../services/tnc-constants.service';
import { TrainingAndCompetencyService } from '../../services/training-and-competency.service';

@Component({
  selector: 'ara-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  routesFlag: { routeName: string, routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string, routeURL: string; isClickable: boolean; }[];
  loggedInUserJSON: any;
  tncFilter: TNCFilter = new TNCFilter();
  tncRecords: TNCUserProfiles[] = [];
  allUnit: any[] = [];
  allUsers: any;
  pageSize: number = 1;
  itemPerPage: number = 50;
  rowCount: number;
  unitList: any[];
  selectedUnit: number[] = [];
  unit:number;
  searchTexts: SearchText = new SearchText();
  allUsersData: any[] = [];
  selectedUserId: number[] = [];
  tncManditoryRecords: TNCUserProfiles[] = [];
  tncJobRelatedRecords: TNCUserProfiles[] = [];
  tncAdditionalRecords: TNCUserProfiles[] = [];
  UserName: any;
  Unit: any;
  EmployeeId: any;
  Designation: any;
  ReportingTo: any;
  Department: any;
  CertificateExpiry: Date;
  display: boolean = false;
  PDFCourseId: number;
  PreviewUrl: string;
  isDownload: boolean = false;
  UserTypeName: string;
  UserTypeIDName: string;
  contextItems: MenuItem[] = [];
  row: HTMLElement;
  selectedCourse : number;

  constructor(
    private baseService: BaseService,
    private TnCService: TrainingAndCompetencyService,
    private masterscreenService: MasterscreenService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationsService: NotificationsService
  ) {
    this.routesFlag = TncConstantsService.TNCNavigation.InnerRoutes;
    this.reportRoutes = TncConstantsService.TNCNavigation.ReportRoutes;
  }

  getUnits(): void {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response): void {
    if (response.Success) {
      this.allUnit = response.Result;
    }
    this.setUsersData();
  }

  setUsersData(): void {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(
      apiRequest,
      this.callbackMethodForGetSearchResultsForUsers.bind(this)
    );
  }
  callbackMethodForGetSearchResultsForUsers(response): void {
    if (response.Success) {
      this.allUsers = response.Result;
      this.allUsersData = [];
      this.allUsers.forEach((s) => {
        this.allUsersData.push({
          label: s.FullName,
          value: s.UserId,
          checked: true,
        });
      });
    }
    let selectedUser = this.route.snapshot.paramMap.get('UserId')
      ? parseInt(this.route.snapshot.paramMap.get('UserId'))
      : this.loggedInUserJSON.UserId;
    this.getTNCUserProfileData(selectedUser);
  }

  getTNCUserProfileData(userId): void {
    const apiRequest = {
      Model: {
        UserId: userId,
      },
    };
    this.TnCService.getTNCUserProfiles(
      apiRequest,
      this.callbackMethodForGetTNCUserProfileData.bind(this)
    );
  }
  callbackMethodForGetTNCUserProfileData(response): void {
    if (response.Success) {
      this.tncRecords = [];
      let tncRecordList = response.Result;
      if (tncRecordList) {
        tncRecordList.forEach((record) => {
          this.tncRecords.push({
            CourseId: record.CourseId,
            UnitId: this.allUnit.find((u) => u.UnitId == record.UnitId) ? this.allUnit.find((u) => u.UnitId == record.UnitId).UnitId : 0,
            UserId: record.UserId,
            NameOfEmployee: this.allUsers.find((u) => u.UserId == record.UserId)
              .FullName,
            Designation: this.allUsers.find((u) => u.UserId == record.UserId)
              .Designation,
            ReportingTo: this.allUsers.find(
              (u) =>
                u.UserId ==
                this.allUsers.find((u) => u.UserId == record.UserId).ReportingTo
            )
              ? this.allUsers.find(
                (u) =>
                  u.UserId ==
                  this.allUsers.find((u) => u.UserId == record.UserId)
                    .ReportingTo
              ).FullName
              : '',
            ParticularName: record.ParticularName,
            DurationFrom: record.DurationFrom,
            DurationTo: record.DurationTo,
            StatusName: record.StatusName,
            Certificate: record.Certificate,
            CertificateId: 0,
            Checked: true,
            CourseStatus: record.CourseStatus,
            Specification: record.Specification,
            CertificationDate: record.CompletionDate ? moment(moment.utc(record.CompletionDate).local()).toDate() : "",
            Validity: record.Validity,
            CertificateExpiryDate: (record.ExpiryDate != 'Lifetime' && record.ExpiryDate) ? moment(moment.utc(record.ExpiryDate).local()).toDate() : "Lifetime",
            ReminderNotification: record.ReminderNotification
          });
        });
      }
    }
    this.baseService.showRootLoader = false;

    let selectedUser = this.route.snapshot.paramMap.get('UserId')
      ? parseInt(this.route.snapshot.paramMap.get('UserId'))
      : this.loggedInUserJSON.UserId;
    this.UserData(selectedUser);
  }

  UserData(UserId): void {
    let user = this.allUsers.find((u) => u.UserId == UserId);
    let UserType = user.UserTypeId;
    this.UserName = user.FullName;
    this.Unit = user.UnitName;
    this.EmployeeId = user.SecondaryId;
    this.Designation = user.Designation;
    this.ReportingTo = this.allUsers.find((u) => u.UserId == user.ReportingTo)
      ? this.allUsers.find((u) => u.UserId == user.ReportingTo).FullName
      : '';
    this.Department = user.DepartmentName;

    if (UserType == 1) {
      this.UserTypeName = "Employee Name";
      this.UserTypeIDName = "Employee ID";
    } else if (UserType == 2) {
      this.UserTypeName = "Contractor Name";
      this.UserTypeIDName = "Contractor ID";
    }

    this.DecideSpecification(UserId);
  }

  DecideSpecification(User): void {
    this.tncManditoryRecords = this.tncRecords.filter(
      (r) => r.Specification == 1 && r.UserId == User
    );
    this.tncJobRelatedRecords = this.tncRecords.filter(
      (r) => r.Specification == 2 && r.UserId == User
    );
    this.tncAdditionalRecords = this.tncRecords.filter(
      (r) => r.Specification == 3 && r.UserId == User
    );
  }

  downloadFile() {
    saveAs(this.PreviewUrl);
  }

  downloadUserProfilePDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    let selectedUser = this.route.snapshot.paramMap.get('UserId')
      ? parseInt(this.route.snapshot.paramMap.get('UserId'))
      : this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: {
        ProcessName: "TNCUserProfile",
        SourceId: selectedUser,
      }
    };
    this.TnCService.downloadUserProfilePDF(apiRequest, this.callbackMethodForDownloadUserProfilePDF.bind(this));
  }

  callbackMethodForDownloadUserProfilePDF(response) {
    if (response) {
      let selectedUser = this.route.snapshot.paramMap.get('UserId')
        ? parseInt(this.route.snapshot.paramMap.get('UserId'))
        : this.loggedInUserJSON.UserId;
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_user_profile_" + this.UserName + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  downloadPDF(CourseId) {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: 'TNCRequest',
        SourceId: CourseId,
        UserId: this.loggedInUserJSON.UserId,
      },
    };
    this.TnCService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = 'pdf_tnc.pdf'; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }

  ngOnInit(): void {
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openTNCCourse()
      }
    ];
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.getUnits();
    let routes = JSON.stringify(TncConstantsService.TNCNavigation.Routes);
    this.routesFlag = JSON.parse(routes);
    const tncPermissions = JSON.parse(this.baseService.getItemFromSession("UserIndependentPermissions"));
    if (!tncPermissions.TNC_Add && !tncPermissions.TNC_Add_Unit && !tncPermissions.TNC_Admin && !tncPermissions.TNC_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === 'Assign Training/Certification') {
          this.routesFlag.splice(index, 1);
        }
      }
    }
  }

  showContextMenu(tncRecord:any) {
    this.selectedCourse = tncRecord.CourseId;
    this.unit = tncRecord.UnitId;
  }
  openTNCCourse() {
    window.open(
      "/tnc/assign-training/" + this.selectedCourse+';unitId=' + this.unit,"_blank"
    );
    this.contextMenu.hide();
  }
  updateReminderNotification(tncRecord,checked){
    const apiRequest = {
      Model: {
        ReminderNotification: checked,
        CourseId: tncRecord.CourseId,
        UserId: tncRecord.UserId,
      },
    };
    this.TnCService.updateTnCReminderNotification(
      apiRequest,
      this.callbackMethodForUpdateReminderNotification.bind(this)
    );
  }
  callbackMethodForUpdateReminderNotification(response) {
    if (response) {
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Reminder Notification updated successfully"
      );
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Issue updating Reminder Notification"
      );
    }
  }
}
